import React, { Component } from 'react';  
import { hashHistory } from 'react-router';
import { Toast } from 'antd-mobile/lib';
import Util from '../util';
let ua=navigator.userAgent.toLowerCase()
export default class NullView extends Component {
    componentWillMount() {
    	if (ua.indexOf("amcfmapp")>-1) {
            let have='没有关闭方法,1秒提示消失';
            if (ua.indexOf("wkwebview")>-1) {
                if (window.webkit) {
                    have='有window.webkit关闭方法,1秒提示消失';
                    // Toast.info(have, 1,()=>{
                        window.webkit.messageHandlers.amcfm_utils.postMessage({"refreshHome":"intelInvest"});
                        window.webkit.messageHandlers.amcfm_utils.postMessage({"finish":""});
                    // });
                }
            }else{
                if (window.amcfm_utils) {
                have='有window.amcfm_utils关闭方法,1秒提示消失';
                    // Toast.info(have, 1,()=>{
                        window.amcfm_utils.refreshHome('intelInvest');
                        window.amcfm_utils.finish();
                    // });
                }
            }
            
    	}else{
            // hashHistory.push({
            //     pathname: '/',
            //   });
            // let app_index=sessionStorage.getItem('app_index')-0;
            // if (app_index!=null) {
            //     console.log(app_index-window.history.length)
            //     setTimeout(function(){
            //         alert(app_index)
            //         alert(window.history.length)
            //         hashHistory.go(app_index-window.history.length);
            //     },200)
            // }
            hashHistory.go(1-window.historyData.length)
    	}
    }
    render() {
        return (
            <div></div>
        )
    }
} 


// WEBPACK FOOTER //
// ./src/components/NullView.js